import { observer } from 'mobx-react';
import { utils, hoc, level, user, request, config, publicApi, getUrl, globalPageConfig } from 'lib';
import { useGlobalStore } from 'stores';
import { PayLevel, UiToast, UiModal } from 'components';
import PopupWrap from './popup-styled';

const Popup = observer((props) => {
  let { close } = props;
  let { isLogin, userInfo } = useGlobalStore();

  const { enableGuildIncome } = globalPageConfig.useConfig();

  // let coinData = level.getCoinLevel(userInfo.finance.coin_spend_total);
  // let richData = level.getRichLevel(userInfo.finance.coin_spend_total);
  // let starData = level.getStarLevel(userInfo.finance.bean_count_total)

  // 暂时使用老版本WWW代码
  const showStarCenterPopup = () => {
    // 测试
    UiModal.iframe({
      // title:'主播中心',
      url: `https://${config.domain.h5}/app/star?access_token=${user.getToken()}`,
      // url: `http://localhost.2339.com:9200/app/star?access_token=${user.getToken()}`,
      width: 428,
      height: 668,
      iframeStyle: {
        overflowX: 'hidden',
        overflowY: 'auto',
      },
    });
  };

  const handleGuildIncome = () => {
    UiModal.iframe({
      url: `https://${config.domain.h5}/app/income/guild?access_token=${user.getToken()}`,
      width: 428,
      height: 668,
      iframeStyle: {
        overflowX: 'hidden',
        overflowY: 'auto',
      },
    });
  };

  const handleGuildEntry = () => {
    const brokerUrl = MM.config.domain.brokerAdmin + '?access_token=' + MM.user.getToken();

    window.open(brokerUrl);
  };

  const onLogout = () => {
    user.logout();
  };

  return (
    <PopupWrap className="shadow fadeInUp animated speed-400">
      <div className="popup-top">
        <img className="popup-top-img" src={userInfo.pic} alt={userInfo.nick_name} />
        <div className="user-nickname">{userInfo.nick_name}</div>
        <div className="user-id">ID: {userInfo._id}</div>
        <div className="user-level">
          <PayLevel level={userInfo.pay_level_info.level} forceShow></PayLevel>
        </div>
        <div className="user-coin-bean clearfix">
          <div className="user-coin-count">
            <i className="icon-user-coin"></i>
            <span>{userInfo.finance.coin_count}</span>
          </div>
        </div>
        <button onClick={user.redirectPay} className="btn btn-red btn-charge">
          充值
        </button>
        <div className="user-um"></div>
      </div>
      <div className="popup-bottom">
        <div className="clearfix">
          <a href="/user.html" target="_blank">
            <i className="icon-user-center"></i>
            <span>个人中心</span>
          </a>
          <a href={`/u/${userInfo._id}`} target="_blank">
            <i className="icon-home-page"></i>
            <span>我的主页</span>
          </a>
          {userInfo.priv === 2 && (
            <a
              className="star-center-item"
              onClick={showStarCenterPopup}
              data-sa="id=000b026&text=主播中心"
            >
              <i className="icon-apply-live"></i>
              <span>主播中心</span>
            </a>
          )}
          <a
            href={
              userInfo.family ? '/family/' + userInfo.family.family_id : '/user.html#a=noFamily'
            }
            target="_blank"
          >
            <i className="icon-family"></i>
            <span>我的家族</span>
          </a>
          <a href="/user.html#a=consume" target="_blank">
            <i className="icon-pay-log"></i>
            <span>消费记录</span>
          </a>
          {userInfo.priv !== 2 && userInfo.priv !== 5 && (
            <a href="/apply" target="_blank">
              <i className="icon-apply-live"></i>
              <span>申请开播</span>
            </a>
          )}

          {userInfo.priv === 5 && (
            <a onClick={handleGuildEntry}>
              <i className="icon-sign-entry"></i>
              <span>公会长后台</span>
            </a>
          )}
          {userInfo.priv === 5 && enableGuildIncome && (
            <a onClick={handleGuildIncome}>
              <i className="icon-guild-income"></i>
              <span>公会账单</span>
            </a>
          )}
        </div>
      </div>
      <a onClick={onLogout} className="user-logout-btn">
        <i className="icon-logout"></i>
        <span>退出登录</span>
      </a>
    </PopupWrap>
  );
});

export default Popup;
